import {
  actionTypes as asyncTypes,
  isAsyncOperation,
  isAsyncComplete,
} from "async-ops";
import {
  isMdaeWidgetOptionChangeEvent,
  updateStateAfterWidgetOptionChange,
} from "../../../../../common_components/mdae-framework";
import { GET_CURATED_CPT_CODE_LIST } from "../services/get-curated-cpt-code-list";
import { GET_CUSTOM_CODE_REFERENCE_DATA } from "../services/get-custom-code-reference-data";
import { GET_LINE_ITEM_PROCEDURE_CODE_LIST } from "../services/get-line-item-procedure-code-list";

export const TOGGLE_LINE_ITEM_PROCEDURE_CODES_LIST_ACTION_POPOVER =
  "TOGGLE_LINE_ITEM_PROCEDURE_CODES_LIST_ACTION_POPOVER";
export const TOGGLE_UPLOAD_CUSTOM_CODES_POPUP =
  "TOGGLE_UPLOAD_CUSTOM_CODES_POPUP";
export const UPDATE_TEMP_CUSTOM_CODE_LIST = "UPDATE_TEMP_CUSTOM_CODE_LIST";
export const TOGGLE_CUSTOM_CODE_WARNING_POPOVER =
  "TOGGLE_CUSTOM_CODE_WARNING_POPOVER";
export const TOGGLE_CUSTOM_CODE_DETAIL_POPUP =
  "TOGGLE_CUSTOM_CODE_DETAIL_POPUP";
export const SET_CUSTOM_CODE_DETAIL_FORM_DATA =
  "SET_CUSTOM_CODE_DETAIL_FORM_DATA";
export const TOGGLE_CUSTOM_CODE_WARNING_POPUP =
  "TOGGLE_CUSTOM_CODE_WARNING_POPUP";
export const UPDATE_CUSTOM_CODE_DATAGRID_DATA =
  "UPDATE_CUSTOM_CODE_DATAGRID_DATA";
export const SET_CURRENT_CUSTOM_CODE_ROW_DATA =
  "SET_CURRENT_CUSTOM_CODE_ROW_DATA";

const initialState = {
  isLoading: false,
  lineItemProcedureCodeList: [],
  isUploadCustomCodePopupVisible: false,
  curatedCptCodeList: [],
  tempCustomCodeList: [],
  currentCustomCode: {},
};

export default function(state = initialState, action) {
  let newState;
  switch (action.type) {
    case TOGGLE_LINE_ITEM_PROCEDURE_CODES_LIST_ACTION_POPOVER:
    case TOGGLE_UPLOAD_CUSTOM_CODES_POPUP:
    case UPDATE_TEMP_CUSTOM_CODE_LIST:
    case TOGGLE_CUSTOM_CODE_WARNING_POPOVER:
    case TOGGLE_CUSTOM_CODE_DETAIL_POPUP:
    case SET_CUSTOM_CODE_DETAIL_FORM_DATA:
    case TOGGLE_CUSTOM_CODE_WARNING_POPUP:
    case SET_CURRENT_CUSTOM_CODE_ROW_DATA:
      newState = { ...state };
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        newState = { ...newState, ...action.data };
      }
      return newState;
    case asyncTypes.OPERATION:
    case asyncTypes.COMPLETE:
    case asyncTypes.FAILURE:
      if (isAsyncOperation(GET_LINE_ITEM_PROCEDURE_CODE_LIST)(action)) {
        return { ...state, lineItemProcedureCodeList: [] };
      }
      if (isAsyncComplete(GET_LINE_ITEM_PROCEDURE_CODE_LIST)(action)) {
        const response = action.response;
        return {
          ...state,
          lineItemProcedureCodeList: response.lineItemProcedureCodeList,
        };
      }
      if (isAsyncOperation(GET_CURATED_CPT_CODE_LIST)(action)) {
        return { ...state, curatedCptCodeList: [] };
      }
      if (isAsyncComplete(GET_CURATED_CPT_CODE_LIST)(action)) {
        const response = action.response;
        return {
          ...state,
          curatedCptCodeList:
            response?.length > 0
              ? response?.filter((x) => x.custom === "N")
              : [],
        };
      }
      if (isAsyncOperation(GET_CUSTOM_CODE_REFERENCE_DATA)(action)) {
        return {
          ...state,
          uploadTypeList: [],
          serviceTypeList: [],
        };
      }
      if (isAsyncComplete(GET_CUSTOM_CODE_REFERENCE_DATA)(action)) {
        const response = action.response;
        return {
          ...state,
          uploadTypeList: response?.uploadTypeList,
          serviceTypeList: response?.serviceTypeList,
        };
      }
      return state;
    default:
      return state;
  }
}
